<main>
    <!-- Section -->
    <section class="vh-lg-100 bg-soft d-flex align-items-center">
        <div class="container">
            <div class="row justify-content-center form-bg-image" data-background-lg="../../assets/img/illustrations/signin.svg">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                        <div class="text-center text-md-center mb-4 mt-md-0">
                            <h1 class="mb-0 h3">Sign in to databroadcaster</h1>
                        </div>
                        <div class="mt-4">
                            <!-- Form -->
                            <div class="form-group mb-4">
                                <label for="email">Your Email</label>
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon1"><span class="fas fa-envelope"></span></span>
                                    <input type="email" class="form-control" placeholder="example@company.com" bind:value={login} required>
                                </div>  
                            </div>
                            <!-- End of Form -->
                            <div class="form-group">
                                <!-- Form -->
                                <div class="form-group mb-4">
                                    <label for="password">Your Password</label>
                                    <div class="input-group">
                                        <span class="input-group-text" id="basic-addon2"><span class="fas fa-unlock-alt"></span></span>
                                        <input type="password" placeholder="Password" class="form-control" bind:value={pwd} required>
                                    </div>  
                                </div>
                                <!-- End of Form -->
                                <div class="d-flex justify-content-between align-items-center mb-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck5">
                                        <label class="form-check-label" for="defaultCheck5">
                                            Remember me
                                        </label>
                                    </div>
                                    <div><span class="small text-right" on:click={resetPwd} style="cursor: pointer;">Lost password?</span></div>
                                </div>
                            </div>
                            {#if notifMsgs.length}
                            {#each notifMsgs as msg}
                            <div class="alert alert-{msg.level}" role="alert">
                                {msg.text}
                            </div>
                            {/each}
                            {/if}
                            <button class="btn btn-block btn-primary" on:click={sendLogin}>Sign in</button>
                        </div>
                        
                        <div class="d-flex justify-content-center align-items-center mt-4">
                            <span class="font-weight-normal">
                                Not registered?
                                <a href="/#/user/register" class="font-weight-bold">Create account</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>


<script lang='ts'>
import {push} from 'svelte-spa-router'

import {App} from '../dbclib/App.js'
import {User} from '../dbclib/User.js'
import {axiosPost} from '../c0utils.js'

import {stApp} from '../dbclib/App.js'
import { DBC_URL, stLang } from '../store.js';

const t = $stLang['en']

let notifMsgs = []

let login = ''
let pwd = ''

let user = new User()

function sendLogin() {
    console.log("send login")
    axiosPost(DBC_URL + '/user/login', {
        USER: {
            login: login,
            pwd: pwd
        }
    })
    .then((result) => {
        console.log("then result", result)
        if(result.ok) {
            $stApp.user = user.from_result(result)
            if($stApp.user.login) {
                App.save()
                .then(() => push('/channels'))
            }
        }
        else notifMsgs = result.queueMsg(t, notifMsgs)
    })
}

function resetPwd() {
    if(login) {
        axiosPost(DBC_URL + '/user/pwd/reset/mail', {
            USER: {
                login: login
            }
        })
        .then((result) => {
            notifMsgs = result.queueMsg(t, notifMsgs)
        })
    }
    else notifMsgs = notifMsgs.push({level: 'danger', 'text': 'Please enter your email'})
}

</script>